import { OrderItemDetailsOrderLogReadDtoActionTypeEnum } from "@/config/apiClient";

export const NOTIFICATIONS_PAGE_SIZE = 50;
export const NOTIFICATIONS_BATCH_SIZE = 20;

export const ACTION_TYPES_WITH_FILES: OrderItemDetailsOrderLogReadDtoActionTypeEnum[] =
  [
    OrderItemDetailsOrderLogReadDtoActionTypeEnum.QuoteAvailable,
    OrderItemDetailsOrderLogReadDtoActionTypeEnum.QuoteValidated,
    OrderItemDetailsOrderLogReadDtoActionTypeEnum.QuoteRefused,
    OrderItemDetailsOrderLogReadDtoActionTypeEnum.ConfirmProof,
    OrderItemDetailsOrderLogReadDtoActionTypeEnum.RefusedProof,
    OrderItemDetailsOrderLogReadDtoActionTypeEnum.AddExtraAttachment,
  ];
